import { Box, Chip, Divider, Typography } from "@mui/material";
import { Error, Info, Warning } from "@mui/icons-material";
import { LogEntry as LogEntryType } from "../../interface/returnOps";

interface LogEntryProps {
    log: LogEntryType;
    showDivider: boolean;
}

const getLogLevelColor = (level: LogEntryType["level"]) => {
    switch (level) {
        case "error":
            return "error";
        case "warn":
            return "warning";
        case "info":
            return "info";
        case "debug":
            return "default";
        default:
            return "default";
    }
};

const getLogLevelIcon = (level: LogEntryType["level"]) => {
    switch (level) {
        case "error":
            return <Error sx={{ fontSize: 16 }} />;
        case "warn":
            return <Warning sx={{ fontSize: 16 }} />;
        case "info":
            return <Info sx={{ fontSize: 16 }} />;
        default:
            return null;
    }
};

const LogEntry = ({ log, showDivider }: LogEntryProps) => (
    <Box sx={{ mb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <Chip
                label={log.level.toUpperCase()}
                color={getLogLevelColor(log.level)}
                size="small"
                icon={getLogLevelIcon(log.level) as any}
            />
            <Typography
                variant="caption"
                sx={{ color: "text.secondary", minWidth: 150 }}
            >
                {new Date(log.timestamp).toLocaleString()}
            </Typography>
        </Box>
        <Typography variant="body2" sx={{ mt: 0.5, ml: 2 }}>
            {log.message}
        </Typography>
        {Object.keys(log.metadata ?? {}).length > 0 && (
            <Box sx={{ ml: 2, mt: 0.5 }}>
                {Object.entries(log.metadata).map(([key, value]) => (
                    <Typography
                        key={key}
                        variant="caption"
                        sx={{ display: "block", color: "text.secondary" }}
                    >
                        {key}: {String(value)}
                    </Typography>
                ))}
            </Box>
        )}
        {showDivider && <Divider sx={{ my: 1 }} />}
    </Box>
);

export default LogEntry;
